import { formatMaterialUnitLabel } from './formatMaterialUnitLabel';
import { resolveUnitId } from './resolveUnitId';

/**
 * unit_options → FloatingSelect options（略過無 id）。
 * @param {Array<object>|null|undefined} unitOptions
 * @returns {{ value: string, label: string, baseUnit: boolean }[]}
 */
export function mapUnitOptionsToSelectOptions(unitOptions) {
  if (!Array.isArray(unitOptions)) {
    return [];
  }

  return unitOptions
    .map((unit) => {
      const id = resolveUnitId(unit);
      if (!id) {
        return null;
      }
      return {
        value: id,
        label: formatMaterialUnitLabel(unit),
        baseUnit: unit?.baseUnit === true,
      };
    })
    .filter(Boolean);
}
